import { useEffect } from 'react';

const Contact = () => {
  useEffect(() => {
    // Redirect to Vaidhyamegha contact page
    window.open('https://vaidhyamegha.com/contact', '_blank');
  }, []);

  return null; // Return null as we're just redirecting
};

export default Contact;
